import { useQueries } from "@tanstack/react-query";
import type { AreaMapResponse } from "@/features/deployment-dashboard/shared/api/area-map-response";
import {
  areaMapQueryKey,
  buildAreaMapPath,
} from "@/features/deployment-dashboard/shared/api/area-map-query";
import { useRuntimeHttpClient } from "@/features/runtime-session/hooks/use-runtime-http-client";

/**
 * Fetches map data for each requested deployment area. Queries use the same
 * cache keys as `useAreaMap`, so the displayed area's map is shared rather
 * than requested twice.
 */
export function useAreaMaps(deploymentId: string, areaIds: string[]) {
  const runtime = useRuntimeHttpClient();
  const hasAreasListGrant = runtime.operationGrants.some(
    (grant) => grant.operation_id === "areas_list"
  );
  const client = runtime.client;
  const enabled = Boolean(client) && runtime.deploymentId === deploymentId && hasAreasListGrant;

  return useQueries({
    queries: areaIds.map((areaId) => ({
      queryKey: areaMapQueryKey(deploymentId, areaId),
      queryFn: () => client!.get<AreaMapResponse>(buildAreaMapPath(areaId)),
      enabled,
    })),
  });
}
